import {
  asBoolean,
  asNumber,
  asString,
  isObject,
} from "./model-utils";
import { enumValue, MediaType } from "./enums";

export class ChatMedia {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.mediaId = asString(json._id || json.mediaId);
    this.mediaType = enumValue(MediaType, json.mediaType) || MediaType.FILE;
    this.mediaThumb = asString(json.mediaThumb);
    this.mediaUrl = asString(json.mediaUrl);
    this.mediaSize = asNumber(json.mediaSize);
    this.mediaExt = asString(json.mediaExt);
    this.mediaHeight = asNumber(json.mediaHeight);
    this.mediaWidth = asNumber(json.mediaWidth);
    this.mediaName = asString(json.mediaName);
    this.mediaDisplayName = asString(json.mediaDisplayName);
    this.mediaAuthor = asString(json.mediaAuthor);
    this.mediaTime = asString(json.mediaTime);
    this.mediaDuration = asNumber(json.mediaDuration);
    this.enableSound = asBoolean(json.enableSound) ?? true;
  }

  get isImage() {
    return this.mediaType === MediaType.IMAGE;
  }

  get isVideo() {
    return this.mediaType === MediaType.VIDEO;
  }

  get isAudio() {
    const mediaExt = String(this.mediaExt || "").toLowerCase().trim();
    const normalizedExt = mediaExt.startsWith(".") ? mediaExt : `.${mediaExt}`;
    return (
      this.mediaType === MediaType.AUDIO ||
      [".mp3", ".wav", ".aac", ".m4a", ".ogg", ".opus"].includes(
        normalizedExt,
      )
    );
  }

  get isFile() {
    return this.mediaType === MediaType.FILE && !this.isAudio;
  }

  static fromJson(json: any) {
    return isObject(json) ? new ChatMedia(json) : json;
  }
}
